/**
 * `core/wordpress/mwwpform/mwwpformPrivacyCheck.js`
 * - プライバシーポリシーへの同意ボタン
 *
 * 使用方法:
 * - import {mwwpformPrivacyCheck} from "../wordpress/mwwpform/mwwpformPrivacyCheck.js";
 */


import { barbaEventObserver } from "../../barba/utils/barbaEventObserver.js";


export function mwwpformPrivacyCheck() {
  console.log("🔒 Handling Privacy Agreement...");

  const mwWpFormSubmit = document.querySelector('.mw_wp_form [type="submit"][name="submitConfirm"]');
  const mwWpFormPrivacy = document.querySelector('#privacy-1');

  if (!mwWpFormPrivacy || !mwWpFormSubmit) return;
  mwWpFormSubmit.disabled = true;


  const toggleSubmitButton = (event) => {
    mwWpFormSubmit.disabled = !event.target.checked;
  };

  mwWpFormPrivacy.addEventListener('change', toggleSubmitButton);
  barbaEventObserver.observeEvents([[mwWpFormPrivacy, 'change', toggleSubmitButton]]);
}
